<template>
<v-layout row wrap class="rightbox CSChatThai " v-if="detail" style="border: solid; border-width: 1px; border-color: #1a222c; border-bottom: none; border-top: none; background: #1a222c; overflow: hidden; height: 100%;">
  <ShowImageDialog :dialogshowimage="dialogshowimage" :DetailImage="DetailImage" @closeDialogShowImage="closeDialogShowImage"/>


  <v-flex v-if="shownotes" xl12 md12 sm12 lg12>
    <v-card flat style="background: #1a222c;">
      <v-container style="background: #1a222c; padding:5px; " v-if="!progressNote">
        <v-btn dark icon flat @click="shownotes = !shownotes">
          <v-icon style="color: white !important; font-size: 20px !important;">fas fa-arrow-left</v-icon>
        </v-btn>
        <div style="height: 80vh;" class="scrolling-wrapper">
          <div v-for="(item,index) in listnote" style="padding: 5px; padding-bottom: 0px;padding-top: 20px;" class="noteslist" @click="detailNote(item.note_id)">
            <v-avatar class="user-photonote" style="padding-left: 20px;">
              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" style="width: 35px !important; height: 35px !important;">
              <img v-else-if="item.type ==='business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="width: 35px !important; height: 35px !important;">
              <img v-else-if="item.type ==='bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="width: 35px !important; height: 35px !important;">
              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="width: 35px !important; height: 35px !important;">
            </v-avatar>
            <span style="font-size: 15px; color: white;padding-left: 10px;">{{item.nickname}}</span>
            <p v-if="item.note_data.text.length > 20" style="color: #BDBDBD;padding-top: 10px; font-size: 13px;padding-left: 20px;" v-html="convert(item.note_data.text.substring(0, 20) + '...' ).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
            <p v-else style="color: #BDBDBD;padding-top: 10px;font-size: 13px;padding-left: 20px;" v-html="convert(item.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
            <div style="text-align: right;">
            <span style="font-size: 10px;color: #BDBDBD !important;">
              {{date(item.create_date)}} {{time(item.create_date)}}
            </span>
          </div>
            <v-divider style=" background-color: #bdbdbd5e !important; width: 100%;"></v-divider>
          </div>

        </div>
        <v-fab-transition>
          <v-btn style="background: #2562ae;" fab dark small fixed bottom right @click="dialogCreatenote = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
      <v-container style="background: #1a222c; padding:5px;" v-else>
        <v-progress-linear :indeterminate="progressNote"></v-progress-linear>
      </v-container>
    </v-card>
  </v-flex>

  <v-flex v-if="showalbum" xl12 md12 sm12 lg12>
    <v-card flat style="background: #1a222c;">
      <v-container style="background: #1a222c; padding:5px; " v-if="!progressNote">
        <v-btn dark icon flat @click="showalbum = !showalbum">
          <v-icon style="color: white !important; font-size: 20px !important;">fas fa-arrow-left</v-icon>
        </v-btn>
        <div style="height: 80vh;" class="scrolling-wrapper">
          <div v-for="(item, index) in listalbum" v-if="item.state['status'] != 'delete'" style="padding: 5px; padding-bottom: 0px;padding-top: 20px;" class="noteslist">
            <v-layout row wrap>
              <h3 v-if="item.albums_name !== ''" style="color:white;">{{item.albums_name}}</h3>
              <h3 v-else style="color:white;">{{date(item.create_date)}}</h3>
              <v-spacer></v-spacer>
              <div style="text-align: right;">
                <span style="font-size: 10px;color: #BDBDBD !important;">
                  {{date(item.create_date)}} {{time(item.create_date)}}
                </span>
                <v-btn flat icon color="white" @click="delete_albums(item._id)">
                  <v-icon style="font-size: 16px !important;">far fa-trash-alt</v-icon>
                </v-btn>
              </div>
            </v-layout>
            <v-layout v-if="item.information.length !== 0" @click="detailAlbums(item._id, index)">
              <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                <v-layout row wrap style="max-height: 35vh;" class="scrolling-wrapper">
                  <v-flex v-for="(image, index) in item.information" sm4 md4 lg4 xl4 v-if="image.status == 'active'">
                    <v-card flat tile>
                      <v-card-media :src="image.link" height="15vh" >
                      </v-card-media>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
            <v-layout row wrap v-else justify-center align-center >
              <h4 style="color: white;">{{$t('Dialog.album.noImageAlbum')}} </h4>
            </v-layout>
            <v-divider style=" background-color: #bdbdbd5e !important; width: 100%;"></v-divider>
          </div>
        </div>
        <v-fab-transition>
          <v-btn style="background: #2562ae;" fab dark small fixed bottom right @click="dialogCreatealbums = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
      <v-container style="background: #1a222c; padding:5px;" v-else>
        <v-progress-linear :indeterminate="progressNote"></v-progress-linear>
      </v-container>
    </v-card>
  </v-flex>
  <v-flex v-if="detail.type === 'user' && !shownotes && !showalbum" xl12 md12 sm12 lg12 style="overflow-y: hidden;">
    <v-card flat style="background: #1a222c;">
      <v-container style="background: #1a222c; padding-bottom: 0px !important;     padding-top: 0px;">
        <!-- height: 315px;  -->
        <div style="text-align: right;">
          <RightMenu :detail="detail" @opennotes="opennotes" @openalbum="openalbum" @blockfriend="blockfriend" @openWallpaper="openWallpaper" @unblock="unblock"/>

        </div>
        <v-layout row wrap align-center justify-center style="background: #1a222c; ">
          <v-flex xl12 md12 sm12 lg12 style="justify-content: center; display: flex;">
            <v-avatar size="150px" class="user-photo" style="cursor: pointer !important;" @click="openPictureProfile(detail.data_room[0].profilepicture, detail.data_room[0].type)" >
              <img v-if="detail.data_room[0].profilepicture" :src="detail.data_room[0].profilepicture" class="alligator-turtle">
              <img v-else-if="detail.data_room[0].type === 'business'" src="/static/img/default_profile/business-white.png" class="alligator-turtle">
              <img v-else-if="detail.data_room[0].type === 'bot'" src="/static/img/default_profile/bot-white.png" class="alligator-turtle">
              <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle">
            </v-avatar>
          </v-flex>
          <v-flex xl12 md12 sm12 lg12 style="text-align: center; margin-top: 10px;">
            <p class="text2" style="font-size:20px; color:white; margin-bottom: 0px !important;">{{detail.data_room[0].name}}</p>
            <p class="text2" style="color:#bcbcbc; font-size:12px; margin-bottom: 7px !important;" v-if="detail.data_room[0].type === 'user'">{{detail.data_room[0].status? detail.data_room[0].status:'-'}}</p>
            <p class="text2" style="color:#bcbcbc; font-size:12px;" v-else>{{detail.data_room[0].status? detail.data_room[0].status:'-'}}</p>

            <!-- ปุ่ม video call user -->
            <v-btn icon style="background: green;" v-if="detail.data_room[0].type === 'user' && base_env === 'development'" :disabled="detail.data_room[0].statemember !== 'active'">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall_v2('audio',detail)">phone</v-icon>
            </v-btn>
            <v-btn icon style="background: #1976d2;" v-if="detail.data_room[0].type === 'user' && base_env === 'development'" :disabled="detail.data_room[0].statemember !== 'active'">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall_v2('video',detail)">fas fa-video</v-icon>
            </v-btn>
          </v-flex>


          <!-- ปุ่ม video call -->
   <!--        <v-flex xl12 md12 sm12 lg12 style="text-align: center; margin-top: 0px !important;">
            <v-btn icon style="background: green;">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall('voice',detail.data_room[0])">phone</v-icon>
            </v-btn>
            <v-btn icon style="background: #1976d2;">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall('video',detail.data_room[0])">fas fa-video</v-icon>
            </v-btn>
          </v-flex> -->

        </v-layout>
      </v-container>
      <v-container style="padding-top: 2px !important;">
        <v-tabs centered dark class="layoutsearchweb tabsright" v-model="activeinfo" slot="extension" >
          <v-tab class="headerlist tabsright" key="1" href='#tab-1' style="justify-content: center !important; " >
            <v-icon style=" font-size: 20px !important;">account_box</v-icon>
          </v-tab>
          <!-- <v-tab class="headerlist tabsright" key="2" href='#tab-2' style="justify-content: center !important; ">
            <v-icon style=" font-size: 20px !important;">collections</v-icon>
          </v-tab>
          <v-tab class="headerlist tabsright" key="3" href='#tab-3' style="justify-content: center !important; ">
            <v-icon style=" font-size: 20px !important;">file_copy</v-icon>
          </v-tab> -->
          <v-tab v-if="isAccept === true" class="headerlist tabsright" key="4" href='#tab-4' style="justify-content: center !important;">
            <img style="width: 20px !important;" src="/static/img/icons/privacy-policy.png"/>
          </v-tab>
        </v-tabs>

        <v-tabs-items class="layoutsearchweb CSChatThai" v-model="activeinfo">
          <v-tab-item key="1" id="tab-1" class="layoutsearchweb">
            <v-list dense class="layoutsearchweb" style="background: none !important;margin-top: 4px !important;">
              <v-subheader style="color:white; font-weight: 900;">{{$t('RightSide.header.profile')}}</v-subheader>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon style="color: #1da1f2;" large>email</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-if="detail.data_room[0].email === ''" style="color: white !important;">-</v-list-tile-title>
                  <v-list-tile-title v-else style="color: white !important;">
                    <span class="EndpointUrl">
                      {{detail.data_room[0].email}}
                      <v-icon class="urlcopymessage" style="color:white; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="detail.data_room[0].email">file_copy</v-icon>
                    </span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
          </v-tab-item>

          <!-- image friend -->
          <v-tab-item key="2" id="tab-2" class="layoutsearchweb" style="overflow-y: hidden;">
            <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.image')}}</v-subheader>
            <v-flex sm12 md12 lg12 xl12>
              <div style="background: #1b232d;box-shadow: none !important;" v-if="listimageinroom.length != 0">
                <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                  <v-layout row wrap style="max-height: 35vh;" class="scrolling-wrapper">
                    <v-flex v-for="(memb, i) in listimageinroom" sm4 md4 lg4 xl4 style="cursor: pointer;" >
                      <v-card flat tile>
                         <v-card-media :src="memb.path" height="15vh" @click="zoom(memb)">
                        </v-card-media>
                      </v-card>
                    </v-flex>
                    <v-flex sm4 md4 lg4 xl4 style="cursor: pointer;" v-if="showmoreimage">
                      <v-card flat tile style="background: none;">
                        <v-card-media height="15vh" style="color: white; text-align: center; display: flex;justify-content: center; " @click="getimage(listimageinroom[listimageinroom.length - 1].timestamp)">
                          {{$t('ChatSide.Read.readmore')}}
                        </v-card-media>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
              <p v-else style="color: white; text-align: center;">{{$t('RightSide.noImage')}}</p>
            </v-flex>
          </v-tab-item>
          <!-- file -->
          <v-tab-item key="3" id="tab-3" class="layoutsearchweb">
            <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.file')}}</v-subheader>
            <v-flex sm12 md12 lg12 xl12>
              <div style="background: #1b232d; max-height: 35vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                <v-list two-line dense dark class="layoutsearchweb" v-for="(memb, index) in listfileinroom">
                  <v-list-tile>
                    <v-list-tile-avatar :href="memb.path" target="_blank">
                      <v-icon style="color: #1da1f2;" large> {{extension(memb.path)}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title style="color: white !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank"><span>{{memb.file_name}}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title class="CSChatThai">
                        <v-btn depressed small class="btnallow" :href="memb.path" target="_blank">
                          {{$t('AnswerQuestion.download')}}
                        </v-btn>
                        <v-btn depressed small class="btncancel" @click="sendonebox(memb.tokenmessage)">
                          {{$t('AnswerQuestion.Onebox')}}
                        </v-btn>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index != listfileinroom.length-1"></v-divider>
                </v-list>
                <div style="display: flex;justify-content: center; width: 100%;" v-if="showmorefile">
                  <v-btn depressed dark style="display: flex;justify-content: center; text-transform: none; color: white !important; text-align: center;" class="btncancel" @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                    {{$t('ChatSide.Read.readmore')}}
                  </v-btn>
                </div>
              </div>
              <p v-else style="color: white; text-align: center;">{{$t('RightSide.noFile')}}</p>
            </v-flex>
          </v-tab-item>
          <!-- consent -->
          <v-tab-item key="4" id="tab-4" class="layoutsearchweb">
            <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.privatepolicy')}}</v-subheader>
            <v-flex sm12 md12 lg12 xl12 style="justify-content: center; align-items: center; width: 100%; display: flex;">
              <v-btn outline rounded color="white" @click="getAccesstoken()">
                <span style="color: white;">{{$t('RightSide.header.privatepolicy')}}</span>
              </v-btn>
            </v-flex>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card>
  </v-flex>

  <!-- -------------------------------------------- -->
  <v-flex v-if="detail.type === 'group' && !shownotes && !showalbum" xl12 md12 sm12 lg12>
    <v-card flat style="background: #1a222c;">
      <v-container style="background: #1a222c; padding-top: 0px; padding-bottom: 0px;">
        <!-- height: 300px;  -->
        <div style="text-align: right;">
          <RightMenu :detail="detail" @openQRcode="openQRcode" @opennotes="opennotes" @openalbum="openalbum" @ShowDialog="ShowDialog" @leavegroup="leavegroup" @openWallpaper="openWallpaper"/>
        </div>

        <v-layout row wrap align-center justify-center style="background: #1a222c;">
          <v-flex xl12 md12 sm12 lg12 style="justify-content: center; display: flex; height: 150px;">
            <v-avatar style="cursor: pointer !important;" size="150px" @click="openPictureProfile(detail.picture, 'group')">
              <img v-if="detail.picture" :src="detail.picture" class="alligator-turtle" style="border: 2px #1a222c !important; border-style:  solid !important; cursor: pointer;">
              <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border: 2px #1a222c !important; border-style: solid !important; cursor: pointer;">
            </v-avatar>
          </v-flex>

          <v-flex xl12 md12 sm12 lg12 style="margin-top: 1px;text-align: center; margin-bottom: 1px;">
            <p class="text2" style="font-size:20px; color:white; margin-top: 10px;
              margin-bottom: 10px;"> {{$t('RightSide.group')}}&nbsp;: {{detail.group_name}}
            </p>

            <!-- ปุ่ม video call group -->
     <!--        <v-btn icon style="background: green;" :disabled="detail.statemember !== 'active'">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall('voice',detail)">phone</v-icon>
            </v-btn>
            <v-btn icon style="background: #1976d2;" :disabled="detail.statemember !== 'active'">
              <v-icon color="white" style=" font-size: 20px !important;" @click="openCall('video',detail)">fas fa-video</v-icon>
            </v-btn> -->


          </v-flex>
        </v-layout>
      </v-container>
      <v-container style="padding-top: 2px;" >
        <v-tabs centered dark class="layoutsearchweb tabsright" v-model="activeinfo" slot="extension" v-if="detail.statemember == 'active'">
          <v-tabs-slider color="#2562af"></v-tabs-slider>
          <v-tab class="headerlist tabsright" key="1" href='#tab-1' style="justify-content: center !important;">
            <v-icon style=" font-size: 20px !important;">supervised_user_circle</v-icon>
          </v-tab>
          <v-tab class="headerlist tabsright" key="2" href='#tab-2' style="justify-content: center !important;" v-if="detail.count_pending != '0'">
            <v-icon style=" font-size: 20px !important;">schedule</v-icon>
          </v-tab>
          <!-- <v-tab class="headerlist tabsright" key="3" href='#tab-3' style="justify-content: center !important; ">
            <v-icon style=" font-size: 20px !important;">collections</v-icon>
          </v-tab>
          <v-tab class="headerlist tabsright" key="4" href='#tab-4' style="justify-content: center !important;">
            <v-icon style=" font-size: 20px !important;">file_copy</v-icon>
          </v-tab> -->
        </v-tabs>
         <v-tabs centered dark class="layoutsearchweb tabsright" v-else>
          <v-tabs-slider style="display: none;"></v-tabs-slider>
          <v-tab class="headerlistDisabled tabsright" disabled style="justify-content: center !important;">
            <v-icon style=" font-size: 20px !important;color: #1a222b !important;">supervised_user_circle</v-icon>
          </v-tab>
          <v-tab class="headerlistDisabled tabsright" disabled style="justify-content: center !important;">
            <v-icon style=" font-size: 20px !important;color: #1a222b !important;">schedule</v-icon>
          </v-tab>
          <!-- <v-tab class="headerlistDisabled tabsright" disabled style="justify-content: center !important; ">
            <v-icon style=" font-size: 20px !important;color: #1a222b !important;">collections</v-icon>
          </v-tab>
          <v-tab class="headerlistDisabled tabsright" disabled style="justify-content: center !important;">
            <v-icon style=" font-size: 20px !important;color: #1a222b !important;">file_copy</v-icon>
          </v-tab> -->
        </v-tabs>
        <!-- </v-tabs-bar> -->

        <v-tabs-items class="layoutsearchweb" v-model="activeinfo" v-if="detail.statemember == 'active'">
          <v-tab-item key="1" id="tab-1" class="layoutsearchweb" style="margin-top: 1vh !important;">
            <v-subheader style="color:white; font-weight: 900;" v-if="detail.count_member != '0'"><!-- {{$t('RightSide.member')}} ({{detail.count_member}})

              <v-btn outline small rounded color="white" style="text-transform: none;" @click="ShowDialog('Invite')">
                <v-icon color="white" class="mr-2">group_add</v-icon>
                <span style="color: white; text-transform: none;">{{$t('RightSide.menu.invite')}}</span>
              </v-btn> -->

              <v-layout row wrap align-center justify-center style="background: #1a222c; ">
          <v-flex xl6 md6 sm6 lg6 style="">
            {{$t('RightSide.member')}} ({{detail.count_member}})
          </v-flex>
          <v-flex xl6 md6 sm6 lg6 style="text-align: right;">
            <v-btn outline small rounded color="white" style="text-transform: none;" @click="ShowDialog('Invite')">
                <v-icon color="white" class="mr-2">group_add</v-icon>
                <span style="color: white; text-transform: none;">{{$t('RightSide.menu.invite')}}</span>
              </v-btn>
          </v-flex>
        </v-layout>


            </v-subheader>
            <v-subheader style="color:white;" v-else>{{$t('RightSide.noMember')}}  </v-subheader>
           <!--  <v-layout row wrap justify-center align-center>
              <v-btn outline small rounded color="white" style="text-transform: none;" @click="ShowDialog('Invite')">
                <v-icon color="white" class="mr-2">group_add</v-icon>
                <span style="color: white; text-transform: none;">{{$t('RightSide.menu.invite')}}</span>
              </v-btn>
            </v-layout> -->
            <div style="height: 35vh !important;" class="scrolling-wrapper">
              <v-list two-line dense class="layoutsearchweb" style="background: none !important; cursor: pointer;" v-for="(membactive, index) in memberactive" v-if="detail.count_member != '0'">
                <v-list-tile style="padding-left: 1vh !important; padding-right: 1vh !important;">
                  <v-list-tile-avatar @click="detailFriend(membactive)">
                    <img v-if="membactive.profilepicture" :src="membactive.profilepicture" class="alligator-turtle">
                    <img v-else-if="membactive.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                    <img v-else-if="membactive.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title  style="color: white; white-space: nowrap !important; width: 10em;word-break: break-all !important;" @click="detailFriend(membactive)">
                      {{membactive.nickname}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title v-if="membactive.tokenuser !== token && detail.statemember === 'active'">
                      <v-btn depressed small dark class="btnkickgroup" @click="leavegroupFriend(membactive.tokenuser,membactive.name,index)">{{$t('AnswerQuestion.kickMemberGroup')}}</v-btn>
                    </v-list-tile-sub-title>
                    <!-- <v-list-tile-title style="color: white; white-space: nowrap !important; width: 10em;word-break: break-all !important;">
                      {{membactive.nickname}}
                    </v-list-tile-title> -->
                  </v-list-tile-content>
                  <!-- <v-list-tile-action v-if="membactive.tokenuser !== token && detail.statemember === 'active'">
                    <v-btn depressed small dark class="btnkickgroup" @click="leavegroupFriend(membactive.tokenuser,membactive.name,index)">{{$t('AnswerQuestion.kickMemberGroup')}}</v-btn>
                  </v-list-tile-action> -->
                </v-list-tile>
                <v-divider></v-divider>
              </v-list>
               <v-btn @click="getmember()" class="CSChatThai loadmore" v-if="memberactive.length < parseInt(detail.count_member)">
                {{$t('RightSide.loadmore')}}
              </v-btn>
            </div>
            <v-container style="padding-left: 15vw !important;" v-if="edit === true">
              <v-btn @click="clickedit()" class="CSChatThai">
                {{$t('AnswerQuestion.ok')}}
              </v-btn>
            </v-container>


          </v-tab-item>

          <!-- -------pending Group----------- -->

          <v-tab-item key="2" id="tab-2" class="layoutsearchweb" style="margin-top: 1vh !important;" v-if="detail.count_pending != '0'">
            <v-subheader style="color:white; font-weight: 900;" v-if="detail.count_pending != '0'">{{$t('RightSide.pending')}} ({{detail.count_pending}})</v-subheader>
            <div style="height: 35vh !important;" class="scrolling-wrapper">
              <v-list two-line dense class="layoutsearchweb" style="background: none !important; cursor: pointer;" v-for="(membpending, index) in memberpending" v-if="detail.count_pending != '0'"
                :key="membpending.tokenuser">
                <v-list-tile style="padding-left: 1vh !important; padding-right: 1vh !important;">
                  <v-list-tile-avatar @click="detailFriend(membpending)">
                    <img v-if="membpending.profilepicture" :src="membpending.profilepicture" class="alligator-turtle">
                    <img v-else-if="membpending.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                    <img v-else-if="membpending.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <!-- <v-list-tile-title style="color: white; white-space: nowrap !important; width: 10em;word-break: break-all !important;">
                      {{membpending.nickname}}
                    </v-list-tile-title> -->
                    <v-list-tile-title style="color: white; white-space: nowrap !important; width: 10em;word-break: break-all !important;" @click="detailFriend(membpending)">
                      {{membpending.nickname}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title v-if="detail.statemember == 'active'">
                      <v-btn depressed small dark class="btnallow" @click="cancelsendinvite(membpending.tokenuser,membpending.name)">{{$t('AnswerQuestion.cancelInvite')}}</v-btn>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-btn v-if="detail.statemember == 'active'" depressed small dark class="btnallow" @click="cancelsendinvite(membpending.tokenuser,membpending.name)">{{$t('AnswerQuestion.cancelInvite')}}</v-btn> -->
                </v-list-tile>


                <v-divider></v-divider>


              </v-list>
               <v-btn @click="getpending()" class="CSChatThai loadmore" v-if="memberpending.length < parseInt(detail.count_pending)">
                {{$t('RightSide.loadmore')}}
              </v-btn>
            </div>
          </v-tab-item>

          <!-- -------image Group----------- -->
          <v-tab-item key="3" id="tab-3" class="layoutsearchweb" style="margin-top: 1vh !important;">
            <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.image')}}</v-subheader>
            <v-flex sm12 md12 lg12 xl12 >
              <v-card style="background: #1b232d;box-shadow: none !important;" v-if="listimageinroom.length != 0">
                <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 0px !important;">
                  <v-layout row wrap style="max-height: 38vh;" class="scrolling-wrapper">
                    <v-flex v-for="(image, index) in listimageinroom" sm4 md4 lg4 xl4 style="cursor: pointer;" >
                      <v-card flat tile>
                         <v-card-media :src="image.path" height="15vh" @click="zoom(image)">
                        </v-card-media>
                      </v-card>
                    </v-flex>
                    <v-flex sm4 md4 lg4 xl4 style="cursor: pointer;" v-if="showmoreimage">
                      <v-card flat tile style="background: none;">
                        <v-card-media height="15vh" style="color: white; text-align: center; display: flex;justify-content: center; " @click="getimage(listimageinroom[listimageinroom.length - 1].timestamp)">
                          {{$t('ChatSide.Read.readmore')}}
                        </v-card-media>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              <p v-else style="color: white; text-align: center;"> {{$t('RightSide.noImage')}}</p>
            </v-flex>
          </v-tab-item>

          <!-- -------file Group----------- -->
          <v-tab-item key="4" id="tab-4" class="layoutsearchweb" style="margin-top: 1vh !important;">
            <v-subheader style="color:white;font-weight: 900;">{{$t('RightSide.header.file')}}</v-subheader>
            <v-flex sm12 md12 lg12 xl12>
              <v-card style="background: #1b232d; max-height: 35vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                <v-list dark two-line dense class="layoutsearchweb" v-for="(file, index) in listfileinroom">
                  <v-list-tile>
                    <v-list-tile-avatar :href="file.path" target="_blank">
                      <v-icon style="color: #1da1f2;" large>{{extension(file.path)}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title style="color: white !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="file.path" target="_blank">
                        <span>{{file.file_name}}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title class="CSChatThai">
                        <v-btn depressed small class="btnallow" :href="file.path" target="_blank">
                          {{$t('AnswerQuestion.download')}}
                        </v-btn>
                        <v-btn depressed small class="btncancel" @click="sendonebox(file.tokenmessage)">
                          {{$t('AnswerQuestion.Onebox')}}
                        </v-btn>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index != listfileinroom.length-1"></v-divider>
                </v-list>
                <div style="display: flex;justify-content: center; width: 100%;" v-if="showmorefile">
                  <v-btn depressed dark style="display: flex;justify-content: center; text-transform: none; color: white !important; text-align: center;" class="btncancel" @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                    {{$t('ChatSide.Read.readmore')}}
                  </v-btn>
                </div>
              </v-card>
              <p v-else style="color: white; text-align: center;"> {{$t('RightSide.noFile')}}</p>
            </v-flex>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card>
  </v-flex>
   <Openwebsite :dialogopenwebsite="dialogopenwebsite" :id="id" :type="type" @closeDialog="closeDialog"></Openwebsite>
  <InviteGroup :dialogInvite="dialogInvite" :memberpending="memberpending" :member="memberactive" :group_id="detail.group_id" @closeInvite="closeInvite" @invitemembergroup="invitemembergroup">
  </InviteGroup>
  <ManageGroup :dialogManageGroup="dialogManageGroup" :detail="detail" @closeManageGroup="closeManageGroup"></ManageGroup>
  <ShowQRCodeGroup :dialogShowQRCode="dialogShowQRCode" :detail="detail" @closeShowQRCodeGroup="closeShowQRCodeGroup"></ShowQRCodeGroup>
  <NoteDialog :dialogNote="dialogNote" :note_id="note_id" @closeNote="closeNote" @editNote="editNote" @removeNote="removeNote"></NoteDialog>
  <CreateNoteDialog :dialogCreatenote="dialogCreatenote" :tokenroom="room" @closeCreatenote="closeCreatenote" @CreateNote="CreateNote"></CreateNoteDialog>
  <AlbumsDialog :dialogAlbums="dialogAlbums" :albums_id="albums_id" @closeAlbums="closeAlbums" @editAlbums="editAlbums" @removeAlbums="removeAlbums"></AlbumsDialog>
  <CreateAlbumsDialog :dialogCreatealbums="dialogCreatealbums" :tokenroom="room" @closeCreatealbums="closeCreatealbums" @CreateAlbums="CreateAlbums"></CreateAlbumsDialog>
  <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
  <Wallpaper :dialogwallpaper="dialogwallpaper" @closeWallpaper="closeWallpaper"></Wallpaper>
  <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>
  <checkconsentdialog :checkconsentDialog="checkconsentDialog" :url_consent="url_consent" @closeDialogConsent="closeDialogConsent"></checkconsentdialog>
  <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>

</v-layout>
<v-layout row wrap class="rightbox CSChatThai" v-else>
</v-layout>
</template>

<script>
import InviteGroup from '@/components/chat/dialog/manage_group/InviteGroupDialog'

import ShowQRCodeGroup from '@/components/chat/dialog/manage_group/ShowQRCodeGroupDialog'
import ManageGroup from '@/components/chat/dialog/manage_group/ManageGroupDialog'
import NoteDialog from '@/components/chat/dialog/notes/NoteDialog'
import CreateNoteDialog from '@/components/chat/dialog/notes/CreateNoteDialog'
import AlbumsDialog from '@/components/chat/dialog/albums/AlbumsDialog'
import CreateAlbumsDialog from '@/components/chat/dialog/albums/CreateAlbumsDialog'
import RightMenu from '@/components/chat/layout/RightMenuSide'
import ShowImageDialog from '@/components/chat/dialog/ShowImageDialog'
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import Openwebsite from  '@/components/chat/dialog/settings/Openwebsite'
import Wallpaper from '@/components/chat/dialog/wallpaper/wallpaper_dialog'
import SaveOnebox from '@/components/chat/dialog/saveonebox/SaveoneboxDialog'
import checkconsentdialog from '@/components/chat/dialog/consent/check_consent_dialog'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
import {Momenttime, Decode} from '@/services'
import {sync} from 'vuex-pathify'
// import DetailFriend from '@/components/chat/DetailFriend'
// import VueGallerySlideshow from 'vue-gallery-slideshow'
import vuegalleryslideshow from '@/components/chat/gallery-slideshow'
var _ = require('lodash')
// import '/static/style/menu.scss'
import { Encode } from '@/services'
export default {
  data: () => ({
    checkBrowserInfor: {},
    checkBrowserDialog: false,
    dataConsent: '',
    isAccept: false,
    checkconsentDialog: false,
    url_consent: '',
    share_token: '',
    Bot_idcovid: process.env.Bot_idcovid,
    images: [],
    index: null,
    dialogshowimage: false,
    dialogshowimage_profile: false,
    dialogAlbums: false,
    dialogCreatealbums: false,
    progressNote: false,
    detail: {},
    showmorefile: false,
    showmoreimage: false,
    showmorealbums: false,
    dialogNote: false,
    dialogManageGroup: false,
    note_id: '',
    albums_id: '',
    friend: '',
    token: '',
    // noti: false,
    members: {},
    membersGroup: {},
    member: [],
    memberpending: [],
    dialogInvite: false,
    dialogShowQRCode: false,
    LeaveGroup: false,
    SetpicGroup: false,
    edit: false,
    room: '',
    activeinfo: 'tab-1',
    // DetailFriend: '',
    relation: '',
    tokenMember: [],
    tokenMemberpending: [],
    listimageinroom: [],
    listfileinroom: [],
    listnote: [],
    selectFile: '',
    dateSend: '',
    timeSend: '',
    nicknameSend: '',
    filenameSend: '',
    tokenmsgSend: '',
    pathSend: '',
    picSend: '',
    name: '',
    typeuser: '',
    shownotes: false,
    dialogCreatenote: false,
    dialogopenwebsite: false,
    dialogSaveOnebox: false,
    id: '',
    type: '',
    showalbum: false,
    listalbum: [],
    filter_infoalbum: [],
    show: false,
    DetailImage: {},
    pathpicture: '',
    typepathpicture: '',
    dialogwallpaper: false,
    tokenmessage_savebox: '',
    // memberpending: [],
    memberactive: [],
    pagemember: 0,
    pagepending: 0,
    limit: 10,
    oneid_user: '',
    oneid_friend: '',
    base_env: process.env.NODE_ENV
  }),
  methods: {
    closeDialogConsent (value) {
      this.url_consent = ''
      this.checkconsentDialog = value
    },
    delete_albums (albumsid) {
      this.$swal({
        text: this.$t('Alert.Album.deleteAlbum'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/delete_albums', {
            albums_id: albumsid,
            tokenuser: this.token,
            tokenroom: this.$route.params.roomid
          }).then((response) => {
            if (response.data.status === 'success') {
              var index = _.findIndex(this.listalbum, function(o) { return o._id == albumsid })
              this.listalbum.splice(index, 1)
            } else {
              this.$swal(
                '',
                this.$t('Alert.Fail.default.somethingWrong'),
                'error'
              )
            }
          })
        }
      })
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = value
    },
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    openalbum (value) {
      this.showalbum = value
    },
    openWallpaper (value) {
      // console.log(value)
      this.dialogwallpaper = value
    },
    opennotes (value) {
      this.shownotes = value
    },
    clearchat () {
      this.$swal({
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.chIsactive = this.$route.params.roomid
        }
      })
    },
    openQRcode (value) {
      this.dialogShowQRCode = value
    },
    getOneIDUser (tokenuser) {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${tokenuser}`).then((response) => {
        if (response.data.status === 'success') {
          this.oneid_user = response.data.one_id
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getOneIDFriend (tokenuser) {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${tokenuser}`).then((response) => {
        if (response.data.status === 'success') {
          this.oneid_friend = response.data.one_id
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openCall_v2 (typecall, detailroom) {
      console.log(typecall)
      var option_call = ''
      if (typecall === 'audio') {
        option_call = 'voice'
      } else {
        option_call = typecall
      }
      var headers = { headers: { Authorization: 'Bearer Abe49824c8f7d5416a840541ded27fe67dc8aa755ef1a4c99a162513727b5d8c1fd327a9554ba4476b14514092c6635aa12' } }
      var body = { sender: this.oneid_user, to: this.oneid_friend, option: option_call }
      var infor_call = {
        picture: detailroom.data_room[0].profilepicture,
        nickname: detailroom.data_room[0].name,
        one_id: this.oneid_user,
        option: option_call
      }
      this.axios.post(process.env.APIalpine + `/api/v1/gen-token-agora`, body, headers).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          // console.log(response.data.agora_token)
          window.open(`/chat/room/call/${typecall}/?token=${Encode.encodeToken(response.data.agora_token)}&channel_name=${Encode.encodeToken(response.data.channel_name)}&user_infor=${Encode.encode(infor_call)}`, '_blank')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openCall (typecall, detailroom) {
      // console.log(detailroom.type)
      var name = ''
      if (detailroom.type === 'group') {
        name = detailroom.group_name
      }
      // this.axios.post(process.env.APIimage + '/push_conference', {
      //   tokenuser: this.token,
      //   tokenroom: detailroom.tokenroom,
      //   // room_name: name,
      //   type_call: typecall
      // }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data['status'] === 'success') {
      //     window.open(response.data.data.information.urlroom)
      //   }
      // })
      this.axios.post(process.env.APIalpine + '/api/v1/call-agora', {
        tokenuser: this.token,
        tokenroom: detailroom.tokenroom,
        // room_name: name,
        option: typecall
      }).then((response) => {
        console.log(response.data)
        if (response.data['status'] === 'success') {
          // window.open('/chat/room/test/'+typecall +'/'+detailroom.tokenroom+'/?token=' + Encode.encodeToken(this.token) +'&channel_name=' +
          //   Encode.encodeToken(response.data.tokenmessage),'_blank')
          var url = '/chat/room/test/'+typecall +'/'+detailroom.tokenroom+'/?token=' + Encode.encodeToken(response.data.token) +'&channel_name=' + Encode.encodeToken(response.data.tokenmessage)
          this.checkBrowser(url)
        }
      })

      // localStorage.setItem('stateCall', 'true')
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // this.$router.push({
      //   path: '/video_call/' + typecall + '/' + this.room,
      //   force: true
      // })
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    checkBrowser (url) {
      // console.log(url)
      // Get the user-agent string
      let userAgentString = navigator.userAgent;
      // Detect Chrome
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      let operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
       if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
        this.checkBrowserDialog = true
       } else if (safariAgent === true && chromeAgent === true) {
         window.open(url, '_blank')
       } else if (safariAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
         this.checkBrowserDialog = true
      } else {
        window.open(url, '_blank')
      }
    },
    invitemembergroup() {
      // console.log('invitemembergroup')
      // this.getdataroom()
    },
    closeNote(value) {
      this.dialogNote = value
    },
    closeAlbums(value) {
      this.dialogAlbums = value
    },
    closeWallpaper (value) {
      this.dialogwallpaper = value
    },
    closeManageGroup(value) {
      this.dialogManageGroup = value
    },
    closeShowQRCodeGroup(value) {
      this.dialogShowQRCode = value
    },
    closeCreatenote(value) {
      this.dialogCreatenote = value
    },
    closeCreatealbums(value) {
      this.dialogCreatealbums = value
    },
    editNote(msg, id) {
      var indexid = _.findIndex(this.listnote, function(o) {
        return o.note_id === id
      })
      this.listnote[indexid]['note_data']['text'] = msg
    },
    editAlbums(data) {
      if (data.event === 'edit_name') {
        var indexid = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        this.listalbum[indexid]['albums_name'] = data.albums_name
      } else if (data.event === 'add_image') {
        var indexidadd = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        for (var i = 0; i < data.info_albums.length; i++) {
          this.listalbum[indexidadd]['information'].unshift(data.info_albums[i])
        }
      } else if (data.event === 'delete_image') {
        var index_id_delete = _.findIndex(this.listalbum, function(o) {
          return o._id === data.albums_id
        })
        for (var i = 0; i < data.image_id.length; i++) {
          var index_image = _.findIndex(this.listalbum[index_id_delete]['information'], function(o) {
            return o.id === data.image_id[i]
          })
          this.listalbum[index_id_delete]['information'].splice(index_image, 1)
        }
      }
    },
    removeAlbums(id) {
      _.remove(this.listalbum, function(o) {
        return o._id === id
      })
    },
    removeNote(id) {
      _.remove(this.listnote, function(o) {
        return o.note_id === id
      })
    },
    detailNote(id) {
      this.dialogNote = true
      this.note_id = id
    },
    detailAlbums(id, index) {
      this.dialogAlbums = true
      this.albums_id = id
    },
    cancelsendinvite(tokenuser, name) {
      this.$swal({
        text: this.$t('Alert.Right.cancelInvite', {name: name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // this.removeinvite(tokenuser)
          this.axios.post(process.env.APImanage + '/cancelsendinvite', {
            tokenuser: this.token,
            tokenfriend: tokenuser,
            group_id: this.detail.group_id
          }).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.cancelInvite'),
                'success'
              )
              var indexCancelInvite = _.findIndex(this.memberpending, function(o) {
                return o.tokenuser === tokenuser
              })
              if (indexCancelInvite !== -1) {
                this.memberpending[indexCancelInvite].statemember = 'leave'
              }
            }
          })
        }
      })
    },
    closemodal () {
      var modal = document.getElementById('myModalR')
      modal.style.display = 'none'
    },
    closeDialogShowImage (value) {
      this.dialogshowimage = value
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    zoom (image) {
      this.DetailImage = image
      this.dialogshowimage = true
    },
    sendonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
      // this.axios.post(process.env.APIpub + '/save_onebox2', {
      //   tokenmessage: tokenmessage,
      //   tokenuser: this.token
      // }).then((response) => {
      //   if (response.data['status'] === 'success') {
      //     this.$swal(
      //       this.$t('Alert.Success.success'),
      //       this.$t('Alert.Success.sendFiletoOnebox'),
      //       'success'
      //     )
      //   } else {}
      // })
    },
    loadpic (filenameSend) {
      this.axios.get(this.pathSend, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    ShowDialog (dialog) {
      if (dialog === 'Invite') {
        this.dialogInvite = true
      } else if (dialog === 'Leave') {
        this.LeaveGroup = true
      } else if (dialog === 'ManageGroup') {
        this.dialogManageGroup = true
      }
    },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    closeInvite (value) {
      this.dialogInvite = value
    },
    CloseLeave (value) {
      this.LeaveGroup = value
    },
    detailFriend (user) {
      this.id = user.tokenuser
      this.type = 'friend'
      this.dialogopenwebsite = true
    },
    closeDialog () {
      this.dialogopenwebsite = false
    },
    chat (tokenroom) {
      localStorage.setItem('room', tokenroom)
      this.$router.push('/chat/room/' + tokenroom)
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APInew_acceptfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'friend'
        }
      })
    },
    RemoveReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
        }
      })
    },
    AddFriend (tokenFriend) {
      this.axios.post(process.env.APInew_addfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
        } else {
          alert('Error!!!')
        }
      })
    },
    unblock (item) {
      // console.log(item)
      this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {
        tokenuser: this.token
      }).then((response) => {
        var room = response.data['listBlockFriend'][this.findWithAttr(response.data['listBlockFriend'], 'tokenuser', item.tokenuser)]['tokenroom']
        this.axios.post(process.env.APImanage + '/unblockfriend', {
          tokenfriend: item.tokenuser,
          tokenuser: this.token,
          tokenroom: room
        }).then((response) => {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            this.$swal(
              '',
              this.$t('Alert.Success.unblock'),
              'success'
            )
            item.event = 'unblock_friend'
            item.tokenroom = this.$route.params.roomid
            item.state = 'active'
            this.block_friend = item
            this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {
              tokenuser: this.token
            }).then((response) => {
            })
          }
        })
      })
    },
    leavegroupFriend (tokenuser, name, index) {
      this.$swal({
        text: this.$t('Alert.Right.deleteFriendGroup', {name: name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // process.env.APIgo_api + '/v1/kick-group'
          // process.env.APImanage + '/kickmember'
          this.axios.post(process.env.APIgo_api + '/v1/kick-group', {
            group_id: this.detail.group_id,
            tokenuser: this.token,
            listmember: [tokenuser]
          }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.removeFriendGroup'),
                'success'
              )
              // if (index >= 0) {
              //   this.memberactive[index].statemember = 'leave'
              //   this.memberactive.splice(index, 1)
              // }
            }
          })
        }
      })
    },
    blockfriend (tokenuserfriend, name) {
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Blocking', {name: name}),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // console.log(tokenuserfriend)
          this.axios.post(process.env.APImanage + '/blockfriend', {
            tokenfriend: tokenuserfriend,
            tokenuser: this.token,
            tokenroom: this.$route.params.roomid
          }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.block'),
                'success'
              )
              this.block_friend = {
                tokenuser: tokenuserfriend,
                timestamp: response.data.timestamp,
                event: 'block_friend',
                tokenroom: this.$route.params.roomid
              }
              this.relation = 'block'
              // this.$router.push('/chat/homepage')
            }
          })
        }
      })
    },
    clickedit() {
      this.edit = !this.edit
      this.activeinfo = 'tab-1'
    },
    leavegroup() {
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Right.leaveGroup'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // process.env.APImanage + '/leavegroup'
          // process.env.APIgo_api + '/v1/leave-group'
          this.axios.post(process.env.APIgo_api + '/v1/leave-group', {
            group_id: this.detail.group_id,
            tokenuser: this.token,
            listmember: [this.token]
          }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$router.push('/chat/homepage')
            }
          })
        }
      })
    },
    getimage(time) {
      this.axios.post(process.env.APIpub + '/file/twe_img', {
        tokenuser: this.token,
        tokenroom: this.room,
        time_in: time,
        type: this.typeuser
      }).then((response) => {
        if (response.data['data'].length === 20) {
          this.showmoreimage = true
        } else {
          this.showmoreimage = false
        }
        if (time === '') {
          this.listimageinroom = response.data['data']
        } else {
          this.listimageinroom.push.apply(this.listimageinroom, response.data['data'])
        }
      })
    },
    getfile(time) {
      this.axios.post(process.env.APIpub + '/file/twe_file', {
        tokenuser: this.token,
        tokenroom: this.room,
        time_in: time,
        type: this.typeuser
      }).then((response) => {
        if (response.data['data'].length === 20) {
          this.showmorefile = true
        } else {
          this.showmorefile = false
        }
        if (time === '') {
          this.listfileinroom = response.data['data']
        } else {
          this.listfileinroom.push.apply(this.listfileinroom, response.data['data'])
        }
      })
    },
    zoomgroup(src) {
      this.$swal({
        imageUrl: src,
        showCloseButton: true,
        animation: true,
        showCancelButton: false,
        showConfirmButton: false
      })
    },
    extension(path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else {
        return 'fas fa-file-alt'
      }
    },
    // count_memberpendingactive(member) {
    //   return _.filter(member, function(member) {
    //     return member.statemember === 'pending'
    //   })
    // },
    // (member) {
    //   return _.filter(member, function(member) {
    //     return member.statemember === 'active'
    //   })
    // },

    getmember () {
      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post(process.env.APIgo_api + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagemember,
        limit: this.limit,
        filter: 'active'
      }).then((response) => {
        if (response.data.status === 'success') {
         if (this.pagemember == 0) {
          this.memberactive = response.data.member
         } else {
          this.memberactive.push.apply(this.memberactive,response.data.member)
         }
         this.pagemember = this.pagemember + 1
        } else {
          // this.progressNote = false
        }
      })
    },
    getpending () {
      // get member from api jame keep in this.memberpending and this.memberactive
      this.axios.post(process.env.APIgo_api + '/v2/get-user-group', {
        group_id: this.detail.group_id,
        page: this.pagepending,
        limit: this.limit,
        filter: 'pending'
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
         if (this.pagemember == 0) {
          this.memberpending = response.data.member
         } else {
          this.memberpending.push.apply(this.memberpending,response.data.member)
         }
         this.pagepending = this.pagepending + 1
        } else {
          // this.progressNote = false
        }
      })
    },
    convert(msg) {
      var text = msg
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig
      var text1 = text.replace(/</g, '&lt;')
      var text2 = text1.replace(/>/g, '&gt;')
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>')
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>')
      return text4
    },
    CreateNote(status, createdate, noteid, tokenroom, updatedate, text) {
      if (status === 'success') {
        if (_.find(this.listnote, function(o) {
            return o.note_id === noteid
          }) === undefined) {
          this.listnote.unshift({
            create_date: createdate,
            nickname: localStorage.getItem('name'),
            note_data: {
              image: [],
              text: text
            },
            note_id: noteid,
            owner: this.token,
            profilepicture: localStorage.getItem('profilepicture'),
            tokenroom: tokenroom,
            type: localStorage.getItem('type_user'),
            update_date: updatedate
          })
          this.listnote = _.orderBy(this.listnote, 'create_date', 'desc')
          this.listnote = _.unionBy(this.listnote, 'note_id')
        }
      }
    },
    CreateAlbums (status, infoalbums) {
      if (status === 'success') {
        this.listalbum.unshift(infoalbums)
      }
    },
    getnote() {
      this.listnote = []
      this.progressNote = true
      this.axios.post(process.env.APImanage + '/getlistnote2', {
        tokenuser: this.token,
        tokenroom: this.room
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progressNote = false
          this.listnote = response.data.list_note
          // var _ = require('lodash')
          this.listnote = _.orderBy(this.listnote, 'create_date', 'desc')
          this.listnote = _.unionBy(this.listnote, 'note_id')
        } else {
          this.progressNote = false
        }
      })
    },
    date(timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time(timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    getdataroom() {
      this.shownotes = false
      this.detail = {}
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.detail = response.data
          // console.log(this.detail.data_room[0])
          if (this.detail.data_room[0].type === 'bot') {
            this.getConsent(this.detail.data_room[0].tokenuser, this.$route.params.roomid)
          } else {
            // get oneid friend not bot
            this.getOneIDFriend(this.detail.data_room[0].tokenuser)
          }
          // else {
            this.getimage('')
            this.getfile('')
            this.getmember()
            this.getpending()
            if (response.data.statemember === 'active') {
              this.getnote()
              this.getListAlbums()
            }
          // }
        }
      })
    },
    getConsent (botid, tokenroom) {
      this.axios.post(process.env.APIalpine + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = Encode.encode(response.data.data)
            this.$router.push('/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
          } else {
            this.dataConsent = response.data.data
            this.isAccept = response.data.isAccept
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getAccesstoken () {
      this.axios.post(process.env.APInew_getaccesstoken, {
        tokenuser: this.token,
        url: ''
      }).then((response) => {
        if (response.data.status === 'success') {
          this.share_token = response.data.data.url
          this.check_consent(response.data.data.url)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check_consent (token) {
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then((response) => {
        if (response.data.result === 'success') {
          this.url_consent = ''
          // localStorage.setItem('check_consent', response.data.data.status)
          if (response.data.data.status === 'approved') {
            this.checkconsentDialog = true
            this.url_consent = response.data.data.response.elements.choice.url + token
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getListAlbums() {
      this.listalbum = []
      this.progressNote = true
      this.axios.post(process.env.APIpub + '/getlist_albums', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progressNote = false
          this.listalbum = response.data.data
        }
      })
    },
    getnoteid(id) {
      if (_.find(this.listnote, function(o) {
          return o.note_id === id
        }) === undefined) {
        this.axios.post(process.env.APImanage + '/getnote', {
          note_id: id
        }).then((response) => {
          if (response.data.status === 'success') {
            this.listnote.unshift({
              create_date: response.data.list_note[0].create_date,
              nickname: response.data.list_note[0].nickname,
              note_data: {
                image: [],
                text: response.data.list_note[0].note_data.text
              },
              note_id: response.data.list_note[0].note_id,
              owner: response.data.list_note[0].owner,
              profilepicture: response.data.list_note[0].profilepicture,
              tokenroom: response.data.list_note[0].tokenroom,
              type: response.data.list_note[0].type,
              update_date: response.data.list_note[0].update_date
            })
            this.listnote = _.orderBy(this.listnote, 'create_date', 'desc')
            this.listnote = _.unionBy(this.listnote, 'note_id')
          }
        })
      }
    }
  },
  computed: {
    ...sync('*')
  },
  watch: {
    socketmessage () {
      // console.log(this.socketmessage)

      var albums_id = this.socketmessage.file_name
      if (this.socketmessage.message === 'addimage_albums') {
        // console.log(this.listalbum)
        var indexidadd = _.findIndex(this.listalbum, function(o) {
          return o._id === albums_id
        })
        if (indexidadd >= 0) {
          for (var i = 0; i < this.socketmessage.image_add.length; i++) {
            this.listalbum[indexidadd]['information'].unshift(this.socketmessage.image_add[i])
          }
        }
      } else if (this.socketmessage.message === 'delete_images_albums') {
        var albums_id_delete = this.socketmessage.albums_id
        var index_id_delete = _.findIndex(this.listalbum, function(o) {
          return o._id === albums_id_delete
        })
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: albums_id_delete,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.listalbum[index_id_delete]['information'] = response.data.data.information
          for (var i = 0; i < this.listalbum[index_id_delete]['information'].length; i++) {
            var index_image = _.findIndex(this.listalbum[index_id_delete]['information'], function(o) {
              return o.status === 'delete'
            })
            this.listalbum[index_id_delete]['information'].splice(index_image, 1)
          }
        }).catch((error) => {
          if (error.response.data.status === 'fail') {
            console.log(error)
          }
        })
      } else if (this.socketmessage.message === 'create_albums') {
        // console.log('create_albums')
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.listalbum.unshift(response.data.data)
          this.listalbum = _.unionBy(this.listalbum, '_id')
        }).catch((error) => {
          if (error.response.data.status === 'fail') {
            console.log(error)
          }
        })
      }
    },
    socketnote() {
      var id = this.socketnote.note_id
      this.getnoteid(id)
    },
    socketupdate_file() {
      this.listfileinroom.unshift({
        file_name: this.socketupdate_file.file_name,
        file_owner: this.socketupdate_file.nickname,
        path: this.socketupdate_file.message,
        pic_pro: this.socketupdate_file.path_pic,
        timestamp: this.socketupdate_file.timestamp,
        tokenmessage: this.socketupdate_file.tokenmessage,
        tokenuser: this.socketupdate_file.tokenuser,
        typeuser: this.socketupdate_file.type
      })
    },
    socketupdate_img() {
      this.listimageinroom.unshift({
        file_name: this.socketupdate_img.file_name,
        file_owner: this.socketupdate_img.nickname,
        path: this.socketupdate_img.message,
        pic_pro: this.socketupdate_img.path_pic,
        timestamp: this.socketupdate_img.timestamp,
        tokenmessage: this.socketupdate_img.tokenmessage,
        tokenuser: this.socketupdate_img.tokenuser,
        typeuser: this.socketupdate_img.type
      })
    },
    socketremove_friend(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.detail.statemember = 'unfriend'
      }
    },
    socketinvite_group(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.axios.post(process.env.APImanage + '/getuser', {
          owner: this.token,
          tokenuser: data.list_invite
        }).then((response) => {
          // console.log(response.data.user)
          // console.log(this.detail.data_room)
          for (var i = 0; i < response.data.user.length; i++) {
            var user = response.data.user[i]
            if (response.data.user[i].type === 'user') {
              user.statemember = 'pending'
              // this.detail.data_room.push(user)
              user.nickname = response.data.user[i].name
              this.memberpending.push(user)
              this.memberpending = _.unionBy(this.memberpending, 'tokenuser')
              this.detail.count_pending = parseInt(this.detail.count_pending) + 1
            } else {
              user.statemember = 'active'
              // this.detail.data_room.push(user)
              user.nickname = response.data.user[i].name
              this.memberactive.push(user)
              this.memberactive = _.unionBy(this.memberactive, 'tokenuser')
              // this.detail.count_member = parseInt(this.detail.count_member) + 1
            }
          }
        })
      }
    },
    socketleave_group(data) {
      // console.log(data)
      // if (data.tokenroom === this.$route.params.roomid) {
      //   var self = this
      //   data.listkick.forEach(function(item) {
      //     // console.log(element)
      //     if (self.token === item) {
      //       self.detail.statemember = 'leave'
      //     }
      //     var index = _.findIndex(self.detail.data_room, function(o) {
      //       return o.tokenuser === item
      //     })
      //     if (index >= 0) {
      //       self.detail.data_room.splice(index, 1)
      //     }
      //   })
      // }

      if (data.tokenroom === this.$route.params.roomid) {
        // ลบ list user active
        var index = _.findIndex(this.memberactive, function (o) { return o.tokenuser === data.tokenuser })
        if (index >= 0) {
          this.memberactive.splice(index, 1)
        }
        this.detail.count_member = parseInt(this.detail.count_member) - 1
      }
    },
    socket_kickmember(data) {
      // console.log(data)
      // var self = this
      // data.listkick.forEach(function(item) {
      //   if (self.token === item) {
      //     self.detail.statemember = 'leave'
      //   }
      //   var index = _.findIndex(self.detail.data_room, function(o) {
      //     return o.tokenuser === item
      //   })
      //   if (index >= 0) {
      //     self.detail.data_room[index].statemember = 'leave'
      //     self.detail.data_room.splice(index, 1)
      //   }
      // })
      var self = this
      data.listkick.forEach(function (item) {
        // console.log(self.token === item)
        // console.log(item)
        if (self.token === item) {
          self.memberactive.statemember = 'leave'
          self.detail.statemember = 'leave'
        }
        var index = _.findIndex(self.memberactive, function (o) { return o.tokenuser === item })
        // console.log(index)
        if (index >= 0) {
          self.memberactive[index].statemember = 'leave'
          self.memberactive.splice(index, 1)
        }
      })
      this.detail.count_member = parseInt(this.detail.count_member) - 1
    },
    '$route.params.roomid'() {
      this.room = this.$route.params.roomid
      this.memberactive = []
      this.memberpending = []
      this.pagemember = 0
      this.pagepending = 0
      this.activeinfo = 'tab-1'
      this.getdataroom()
    },
    socketactive_group(data) {
      // console.log(data)
      // if (this.detail.type === 'group' && this.detial.count_pending !== '0' && this.detail.group_id === data.groupid) {
      //   var index = _.findIndex(this.detail.data_room, function(o) {
      //     return o.tokenuser === data.tokenuser
      //   })
      //   if (index >= 0) {
      //     this.detail.data_room[index].statemember = 'active'
      //     this.detail.statemember = 'active'
      //   }
      // }
      if (this.detail.group_id === data.groupid) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenuser]}).then((response) => {
          // console.log(response.data.user[0])
          console.log(`state member: ${this.detail.statemember}`)
          this.detail.statemember = 'active'
          // หาข้อมูล user active
          var user = response.data.user[0]
          user.statemember = 'active'
          user.nickname = response.data.user[0].name
          this.memberactive.push(user)
          this.memberactive = _.unionBy(this.memberactive, 'tokenuser')
          // ลบ list user pending ที่เพิ่ง active
          var index = _.findIndex(this.memberpending, function (o) { return o.tokenuser === data.tokenuser })
          if (index >= 0) {
            this.memberpending.splice(index, 1)
          }
          console.log(`member old: ${this.detail.count_member}`)
          this.detail.count_member = parseInt(this.detail.count_member) + 1
          if (response.data.user[0].type !== 'bot') {
            this.detail.count_pending = parseInt(this.detail.count_pending) - 1
          }
          console.log(`member new: ${this.detail.count_member}`)
        })
      }
    },
    socketcencel_group(data) {
      // if (this.detail.type === 'group' && this.detial.count_pending !== '0' && this.detail.group_id === data.group_id) {
      //   var index = _.findIndex(this.detail.data_room, function(o) {
      //     return o.tokenuser === data.tokenuser
      //   })
      //   if (index >= 0) {
      //     this.detail.data_room.splice(index, 1)
      //   }
      // }

      // ลบ list user pending
      var index = _.findIndex(this.memberpending, function (o) { return o.tokenuser === data.tokenuser })
      if (index >= 0) {
        this.memberpending.splice(index, 1)
      }
      this.detail.count_pending = parseInt(this.detail.count_pending) - 1
    }
  },
  created() {
    this.typeuser = localStorage.getItem('type_user')
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.room = this.$route.params.roomid
    this.shownotes = false
    this.showalbum = false
    this.getdataroom()
    // get oneid user
    this.getOneIDUser(this.token)
  },
  components: {
    InviteGroup,
    NoteDialog,
    CreateNoteDialog,
    ManageGroup,
    vuegalleryslideshow,
    ShowQRCodeGroup,
    AlbumsDialog,
    CreateAlbumsDialog,
    RightMenu,
    ShowImageDialog,
    ShowImageProfileDialog,
    Openwebsite,
    Wallpaper,
    SaveOnebox,
    checkconsentdialog,
    CheckBrowserDialog
  }
}
</script>

<style lang="css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.theme--dark.v-tabs__bar {
  background-color: #27303e !important
}
.imageTest {
  width: 100px;
  height: 100px;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
  border: 1px solid lightgray;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}

.btnkickgroup {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #ff3939 !important;
  color: white !important;
  text-transform: none;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}

.rightbox {
  height: 91vh;
  background-color: white;
}

>>>.tabsright {
  background-color: #27303e !important;
}

/*test upload*/
.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.tabs__item--active {
  opacity: 1;
  color: #53ceff !important;
}

.fileInput {
  color: white;
  /*margin-left: 5px;*/
}

.inputWrapper {
  height: 32px;
  width: 70px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  margin-top: 5vh;
  margin-left: 30px;
}

.namemem {
  /*font-family: 'Kanit', sans-serif !important;*/

  font-family: 'CS ChatThaiUI' !important;
  font-weight: 500 !important;
  font-size: 20px;
}

/*.colorDetail {
    color:rgba(0,0,0,.54);*/
.cardfile {
  background-color: #bff9ff;
  width: 500px;
  height: 300px;
  /*margin-left: 10px;*/
}

.cardlist {
  padding-top: 10px;
  width: 100%;
  height: 30vh;
  overflow-x: hidden;
  overflow-y: scroll;
}

.cardlist::-webkit-scrollbar {
  width: 10px;
}

.cardlist::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.selectF {
  background-color: #757575;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}

.nonselectF {
  background-color: #ECEFF1;
  width: 100%;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.textdetail {
  white-space: nowrap;
  width: 20em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-align: left;
}

.text {
  white-space: nowrap;
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}

.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
  text-align: center;

}

.fixed-content {
  min-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.headerlist {
  color: white !important;
  font-weight: 700;
  font-family: 'CS ChatThaiUI' !important;
}
.headerlistDisabled {
  color: #1a222b !important;
  font-weight: 700;
  font-family: 'CS ChatThaiUI' !important;
}

.layoutsearchweb {
  background-color: none;
  color: white !important;
}


/* The Modal (background) */
.modalc {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 9;
  /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw;
  /* Full width */
  height: 100vh;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9);
  /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
/*.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}*/

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

#headcaption {
  margin: auto;
  display: block;

  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  background-color: #1b232d;
  /*height: 150px;*/
}



/* Add Animation - Zoom in the Modal */
.modal-content,
#caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {
    transform: scale(0)
  }

  to {
    transform: scale(1)
  }
}

/* The Close Button */
.closeR {
  position: absolute;
  top: 0px;
  right: 35px;
  color: white;
  font-size: 35px;
  /*font-weight: bold;*/
  transition: 0.3s;
}

.closeR:hover,
.closeR:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.loadmore {
  background: #28303e !important;
    color: white !important;
    box-shadow: none;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: auto;
    border-radius: 6px;
    text-transform: none;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100vw;
  }
}

/*.picgroup:hover {
  background: black !important;
}
*/
.EndpointUrl {
  display: block;
  color: #fff;
}

.EndpointUrl:hover .urlcopymessage {
  display: inline !important;
}

.urlcopymessage {
  display: none !important;
}

.noteslist {
  cursor: pointer;
}

.noteslist:hover {
  cursor: pointer;
  background: #27303e;
}

>>>.v-list__tile {
  padding: 0 6px;
}

>>>.theme--dark.v-list {
  background: #27303e;
}

ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/chat/layout/RightSide.vue